import * as yup from "yup";

import { AutocompleteItem } from "../../../../components/Autocomplete";
import { FormId } from "../../../../components/enums";
import { defaultCountry } from "../../../../shared";
import {
  cityValidatorRequired,
  countryValidatorRequired,
  dateValidatorRequired,
  provinceValidatorRequired,
  textareaValidatorRequired,
  timeValidatorRequired,
} from "../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.INCIDENT_CIRCUMSTANCES]: yup.object({
    [ComponentId.INCIDENT_CIRCUMSTANCES_DATE]: dateValidatorRequired,
    [ComponentId.INCIDENT_CIRCUMSTANCES_HOUR]: timeValidatorRequired,
    [ComponentId.INCIDENT_CIRCUMSTANCES_PLACE]: textareaValidatorRequired(250),
    [ComponentId.INCIDENT_CIRCUMSTANCES_COUNTRY]: countryValidatorRequired,
    [ComponentId.INCIDENT_CIRCUMSTANCES_PROVINCE]: yup
      .string()
      .when(ComponentId.INCIDENT_CIRCUMSTANCES_COUNTRY, {
        is: (country: AutocompleteItem) =>
          country.value === defaultCountry.value,
        then: provinceValidatorRequired,
      }),
    [ComponentId.INCIDENT_CIRCUMSTANCES_CITY]: cityValidatorRequired,
    [ComponentId.INCIDENT_CIRCUMSTANCES_DESCRIPTION]: textareaValidatorRequired(
      10000
    ),
  }),
};
